export function buildServicePageStructuredData({ page, path, pageName, orgDescription }) {
  const base = 'https://antologia.tech';
  const url = `${base}${path}`;
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': `${base}/#organization`,
      name: 'Антология',
      url: base,
      description: orgDescription,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${url}#webpage`,
      url,
      name: pageName,
      isPartOf: { '@id': `${base}/#website` },
      about: { '@id': `${base}/#organization` },
    },
    ...page.services.map((s) => ({
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: s.cardTitle,
      provider: { '@id': `${base}/#organization` },
      areaServed: 'RU',
      description: s.summary,
    })),
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: page.faq.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
  ];
}
